import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

function getCustomerOffers(customerMobile) {
  return fetch(`${casaApiUrl}/users/offers-raw/customer-mobile/${customerMobile}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('offer fetch failed')
    }
  })
}

function getCustomerOffersInCurrentStore(store, customerMobile) {
  return fetch(`${casaApiUrl}/users/offers-raw/store/${store}/customer-mobile/${customerMobile}`, {
    method: 'GET',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('offer fetch failed')
    }
  })
}

function getCustomerAvailableOffers(customerMobile) {
  return fetch(`${casaApiUrl}/users/offers/customer/${customerMobile}`, {
    method: 'GET',
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.status === 200) {
      return response.json()
    } else {
      return Promise.reject('offer fetch failed')
    }
  })
}

function applyDiscount(businessUnitId,body){
  return fetch(`${casaApiUrl}/users/offers/businessUnit/${businessUnitId}/activateOffer`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    return response.json()
  }).catch(err => {
    return Promise.reject('error in offer activation')
  })
}

export default {
  getCustomerOffers,
  getCustomerOffersInCurrentStore,
  getCustomerAvailableOffers,
  applyDiscount
}



// WEBPACK FOOTER //
// ./src/services/offer-service.js